import React from 'react';
import { cn } from '../../lib/utils';

interface StatProps {
    label: string;
    value: string | number;
    suffix?: string;
    icon?: React.ReactNode;
    trend?: 'up' | 'down' | 'neutral';
    className?: string;
}

export const Stat: React.FC<StatProps> = ({
    label,
    value,
    suffix,
    icon,
    trend,
    className,
}) => {
    const trendColors = {
        up: 'text-green-500',
        down: 'text-red-500',
        neutral: 'text-surface-500',
    };

    return (
        <div className={cn('flex items-start gap-3 p-4 rounded-xl bg-surface-50', className)}>
            {icon && (
                <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary-100 text-primary-600">
                    {icon}
                </div>
            )}
            <div className="flex-1">
                <p className="text-xs font-medium text-surface-500 uppercase tracking-wide">{label}</p>
                <div className="flex items-baseline gap-1 mt-1">
                    <span className={cn('text-2xl font-bold', trend ? trendColors[trend] : 'text-surface-800')}>
                        {value}
                    </span>
                    {suffix && <span className="text-sm text-surface-500">{suffix}</span>}
                </div>
            </div>
        </div>
    );
};
